$(() => {
  var form = $('form.edit_integration_implementation');
  form.find('select[multiple="multiple"]').select2()
});
